module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/Coupon_step2_Scheduled_Illustration.f7fa3dd2.svg";